/*
 * @Author: fanxiaoning
 * @Date: 2021-08-04 19:01:17
 * @LastEditors: fanxiaoning
 * @LastEditTime: 2021-09-24 16:10:15
 */
import Vue from "vue";
const view = Vue.extend({ render: h => h("router-view") });

// 课后报告详情-学生端
const reportOfStudent = () =>
  import(
    /* webpackChunkName: "reportOfStudent" */ "@/views/student/afterClassReport/student/index.vue"
  );
// 课后报告详情-老师端
const reportOfTeacher = () =>
  import(
    /* webpackChunkName: "reportOfTeacher" */ "@/views/student/afterClassReport/teacher/index.vue"
  );
// 课后报告详情-微信端
const reportOfWxShare = () =>
  import(
    /* webpackChunkName: "reportOfWxShare" */ "@/views/student/afterClassReport/wxShare/index.vue"
  );

// 随堂报告+新版课后报告-学生端
const classReportOfStudent = () =>
  import(
    /* webpackChunkName: "classReportOfStudent" */ "@/views/student/classReport/student/index.vue"
  );
// 随堂报告+新版课后报告-老师端
const classReportOfTeacher = () =>
  import(
    /* webpackChunkName: "classReportOfTeacher" */ "@/views/student/classReport/teacher/index.vue"
  );
// 随堂报告+新版课后报告-微信端
const classReportOfWxShare = () =>
  import(
    /* webpackChunkName: "classReportOfWxShare" */ "@/views/student/classReport/wxShare/index.vue"
  );
// 美育课课后报告
const aiClassReportStudent = () =>
  import(
    /* webpackChunkName: "aiClassReportStudent" */ "@/views/student/aiClassReport/index.vue"
  );

// 新课后报告详情-学生端
const newReportOfStudent = () =>
  import(
    /* webpackChunkName: "newreportOfStudent" */ "@/views/student/newAfterClassReport/student/index.vue"
  );
// 新课后报告详情-老师端
const newReportOfTeacher = () =>
  import(
    /* webpackChunkName: "newreportOfTeacher" */ "@/views/student/newAfterClassReport/teacher/index.vue"
  );
// 新课后报告详情-微信端
const newReportOfWxShare = () =>
  import(
    /* webpackChunkName: "newreportOfWxShare" */ "@/views/student/newAfterClassReport/wxShare/index.vue"
  );

// 阶段报告详情
const newStageReportOfStudent = () =>
  import(
    /* webpackChunkName: "newStageReportOfStudent" */ "@/views/student/newAfterClassReport/student/stageReportDetail.vue"
  );

export default [
  {
    path: "afterClassReport",
    component: view,
    children: [
      {
        name: "reportOfStudent",
        path: "student",
        component: reportOfStudent
      },
      {
        name: "reportOfTeacher",
        path: "teacher",
        component: reportOfTeacher
      },
      {
        name: "reportOfWxShare",
        path: "wxShare",
        component: reportOfWxShare
      }
    ]
  },
  {
    path: "classReport",
    component: view,
    children: [
      {
        name: "classReportOfStudent",
        path: "student",
        component: classReportOfStudent
      },
      {
        name: "classReportOfTeacher",
        path: "teacher",
        component: classReportOfTeacher
      },
      {
        name: "classReportOfWxShare",
        path: "wxShare",
        component: classReportOfWxShare
      }
    ]
  },
  {
    path: "aiClassReport",
    component: view,
    children: [
      {
        name: "aiClassReportStudent",
        path: "student",
        component: aiClassReportStudent
      }
    ]
  },
  //下面是新版课后报告
  {
    path: "newAfterClassReport",
    component: view,
    children: [
      {
        name: "newReportOfStudent",
        path: "student",
        component: newReportOfStudent
      },
      {
        name: "newReportOfTeacher",
        path: "teacher",
        component: newReportOfTeacher
      },
      {
        name: "newReportOfWxShare",
        path: "wxShare",
        component: newReportOfWxShare
      },
    ]
  },
  // 新版阶段性学习报告
  {
    path: "newStageReport",
    component: view,
    children: [
      {
        name: "newStageReportOfStudent",
        path: "student",
        component: newStageReportOfStudent
      }
    ]
  },
];
